import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Home, BookOpen, BarChart3 } from 'lucide-react';

const TopTabNav: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleNavigation = (path: string, label: string) => {
    navigate(path);
    // Scroll to top when navigating to Today
    if (label === 'Today') {
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    }
  };
  const tabs = [
    { label: 'Today', icon: Home, path: '/dashboard' },
    { label: 'Insights', icon: BarChart3, path: '/analytics' },
    { label: 'Log', icon: BookOpen, path: '/entries' },
  ];
  
  return (
    <nav className="hidden md:flex w-full justify-center bg-white border-b border-gray-200 z-20">
      <div className="flex gap-8 mt-1">
        {tabs.map(({ label, icon: Icon, path }) => {
          const isActive = location.pathname === path;
          return (
            <button
              key={label}
              className="relative flex flex-col items-center px-6 py-2 focus:outline-none group"
              onClick={() => handleNavigation(path, label)}
            >
              <Icon size={22} className={isActive ? 'text-rose-600' : 'text-gray-400 group-hover:text-rose-500 transition-colors'} />
              <span className={`text-sm mt-1 font-medium ${isActive ? 'text-rose-600' : 'text-gray-500 group-hover:text-rose-500'} transition-colors`}>{label}</span>
              <span
                className={`absolute left-0 right-0 -bottom-1 h-1 rounded-full transition-all duration-300 ${isActive ? 'bg-rose-500 w-full' : 'bg-transparent w-0'}`}
                style={{ margin: '0 auto' }}
              />
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default TopTabNav; 